<template>
  <div style="margin-top: 20px">
    <div class="container-fluid">
      <div class="row-fluid">
        <div class="span12">
          <div id="demo" class="carousel slide" data-ride="carousel">
            <!-- 指示符 -->
            <ul class="carousel-indicators">
              <li
                data-target="#demo"
                data-slide-to="index"
                :class="{ active: index == 0 }"
                v-for="(item, index) in list"
                :key="index"
              ></li>
              <!-- <li data-target="#demo" data-slide-to="1"></li>
            <li data-target="#demo" data-slide-to="2"></li> -->
            </ul>

            <!-- 轮播图片 -->
            <div class="carousel-inner">
              <div
                class="carousel-item"
                v-for="(item1, index1) in list"
                :key="index1"
                :class="{ active: index1 == 0 }"
              >
                <img
                  class="center-block carousel-item-img"
                  :src="item1.value_a"
                />
              </div>
              <!-- <div class="carousel-item">
              <img class="center-block carousel-item-img"
                src="https://static.runoob.com/images/mix/img_nature_wide.jpg">
            </div>
            <div class="carousel-item">
              <img class="center-block carousel-item-img"
                src="https://static.runoob.com/images/mix/img_mountains_wide.jpg">
            </div> -->
            </div>

            <!-- 左右切换按钮 -->
            <a class="carousel-control-prev" href="#demo" data-slide="prev">
              <span class="carousel-control-prev-icon"></span>
            </a>
            <a class="carousel-control-next" href="#demo" data-slide="next">
              <span class="carousel-control-next-icon"></span>
            </a>
          </div>

          <div style="height: 40px"></div>
        </div>

        <!--快捷导航-->
        <div class="span12" style="margin-top: 5px">
          <!--t_10-->
          <div class="row">
            <div
              class="col-3"
              @click="route(index2)"
              v-for="(item2, index2) in buttonList"
              :key="index2"
            >
              <span>
                <img :src="item2.value_b" style="width: 30px; height: 30px" />
                <p class="b_t_5">{{ item2.key }}</p>
              </span>
            </div>
            <!-- <div class="col-3" @click="$router.push('/server_user_list')">
            <span>
              <img src="https://img.hsnms.com/20210807/1628340370.png" style="width: 30px; height: 30px;">
              <p class="b_t_5">服务队伍</p>
            </span>
          </div>
          <div class="col-3" @click="$router.push('/mall_list')">
            <span>
              <img src="https://img.hsnms.com/20210808/1628354205.png" style="width: 30px; height: 30px;">
              <p class="b_t_5">爱心商城</p>
            </span>
          </div>
          <div class="col-3" @click="$router.push('/charitable_list')">
            <span>
              <img src="https://img.hsnms.com/20210807/1628340680.png" style="width: 30px; height: 30px;">
              <p class="b_t_5">消息</p>
            </span>
          </div> -->
          </div>
        </div>

        <!--快捷导航-->
        <div class="span12 t_20 text-left">
          <div
            :style="{ backgroundImage: 'url(' + bug2_data[0].value_b + ')' }"
            class="jumbotron jumbotron_aa"
            @click="route1"
          >
            <!-- <img src="../../assets/bj2.jpg" width="300px" /> -->
            <h4 style="color: #fff">{{ bug2_data[0].key }}</h4>
            <h5>{{ bug2_data[0].value_c }}</h5>
          </div>

          <div
            :style="{ backgroundImage: 'url(' + bug2_data[1].value_b + ')' }"
            class="jumbotron jumbotron_bb t_20"
            @click="route2"
          >
            <h4 style="color: #fff">{{ bug2_data[1].key }}</h4>
            <h5>
              <span class="label label-primary label_50">{{
                bug2_data[1].value_d
              }}</span>
              {{ bug2_data[1].value_c }}
            </h5>
          </div>
        </div>

        <!--最新活动-->
        <div class="span12 text-left">
          <div class="page-header">
            <div class="row">
              <div class="col-6">
                <h4>服务推荐</h4>
              </div>
              <div
                class="col-6 text-right"
                @click="$router.push('/server_user_list')"
              >
                <h6 class="text-muted">
                  <samp
                    style="
                      color: #505153;
                      background: #f3f4f8;
                      border: 0;
                      padding: 5px 8px 4px 10px;
                      border-radius: 15px;
                    "
                    >全部&nbsp;</samp
                  >
                </h6>
              </div>
            </div>
          </div>
          <div
            class="jumbotron_c t_20"
            v-for="(item, index) in list4"
            :key="index"
            @click="
              $router.push({
                name: 'server_user_shows',
                query: { id: item.id },
              })
            "
          >
            <div class="row">
              <div class="col-3" style="padding-right: 0px">
                <div style="padding: 10px 0px 10px 10px">
                  <img
                    style="max-width: 70px; height: 70px"
                    :src="item.avatar_url"
                    v-if="item.avatar_url"
                    title="暂无图片"
                  />
                  <div class="imgss" v-else>暂&nbsp;无<br />图&nbsp;片</div>
                </div>
              </div>
              <div class="col-9">
                <h5 class="h5_t_5">
                  <span
                    class="label label-primary label_50"
                    v-if="item.key_id == 1"
                    style="padding-top: 4px"
                    >群团组织</span
                  >
                  <span
                    class="label label-primary label_50"
                    v-if="item.key_id == 2"
                    style="padding-top: 4px"
                    >社会组织</span
                  >
                  <span
                    class="label label-primary label_50"
                    v-if="item.key_id == 3"
                    style="padding-top: 4px"
                    >个人</span
                  >
                  &nbsp;{{ item.describe }}
                </h5>
                <footer
                  class="blockquote-footer"
                  style="
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  "
                >
                  {{ item.title }}
                </footer>
                <h5
                  class="text-right"
                  style="margin-bottom: 0px; padding-top: 3px"
                >
                  <span class="label label-primary-j1">详细信息</span>
                </h5>
              </div>
            </div>
          </div>
          <div
            style="
              color: #666;
              width: 100%;
              height: 28px;
              text-algin: center;
              font-size: 10px;
              margin: 15px auto 10px;
            "
          >
            <p style="margin-bottom: 3px; text-align: center; font-size: 10px">
              本服务由浙江政务服务网、椒江区96345志愿者联合会提供
            </p>
            <p style="text-align: center; font-size: 10px">
              服务咨询热线：<span style="color: #6b9ee6" @click="call"
                >0576-88012365</span
              >
            </p>
          </div>
          <div id="d_p"></div>
        </div>

        <!-- <div class="text-left">
          <div class="page-header">
            <div class="row">
              <div class="col-6">
                <h4>最新求助</h4>
              </div>
              <div class="col-6 text-right" @click="$router.push('/home_help')">
                <h6 class="text-muted">更多>></h6>
              </div>
            </div>
          </div>
          <div class="col-12" style="height: 8px;"></div>
          <div class="row-fluid">
            <div class="span12">
              <div class="jumbotron" v-for="(item,index) in list1" :key="index" style="padding:10px 15px"
                @click="route(item.id)">
                <div class="row b_x tt_x_10" style="padding: 2px 0px 14px;">
                  <div class="col-9" style="padding-left: 10px;">
                    <span class="label"
                      style="color: #3480fa;background-color: #ffd986;border-radius: 50px/50px">未来社区</span>&nbsp;
                    | 05:63
                  </div>
                  <div class="col-3 text-right" style="padding-left:0" v-if="item.assistance_state == 0">等待接单</div>
                  <div class="col-3 text-right" style="padding-left:0" v-if="item.assistance_state == 1">已接单</div>
                  <div class="col-3 text-right" style="padding-left:0" v-if="item.assistance_state == 2">完成结单</div>
                </div>
                <div class="row t_10">
                  <div class="col-12" style="line-height:25px;padding-right:0">
                    <span class="glyphicon glyphicon-bullhorn"></span> {{item.assistance_text}}
                  </div>
                  <div class="row col-12" style="margin-top:5px">
                    <div class="col-3" style="padding-right:0"> <span class="glyphicon glyphicon-user"></span>
                      {{item.username}}</div>
                    <div class="col-9">{{item.telephone}}</div>
                  </div>
                  <div class="col-12" style="height: 3px;"></div>
                  <div class="col-12 t_5 t_x_10">
                    <span class="glyphicon glyphicon-flag"></span> {{item.assistance_address}}
                  </div>
                  <div class="col-12" style="height: 3px;"></div>
                </div>
                <div class="row b_t tt_10 t_x_10" style="margin-bottom:0px">
                  <div class="col-6">
                    <h5>理发服务</h5>
                  </div>
                  <div class="col-6 text-right">
                    <button type="button" class="btn btn-primary" v-if="item.assistance_state == 0">等待接单</button>
                    <button type="button" class="btn btn-primary" v-if="item.assistance_state == 1">已接单</button>
                    <button type="button" class="btn btn-primary" v-if="item.assistance_state == 2">完成结单</button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div id="d_p"></div>

        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      usertype: "",
      jwd: {},
      ticket: "",
      list: [],
      list4: [],
      buttonList: [],
      buttonList1: [
        {
          key: "求助中心",
        },
        {
          key: "组织点单",
        },
      ],
      bug2_data: [
        {
          key: "",
          value_a: "",
          value_b: "",
          value_c: "",
          value_d: "",
        },
        {
          key: "",
          value_a: "",
          value_b: "",
          value_c: "",
          value_d: "",
        },
      ],
    };
  },
  components: {
    //zlb
  },
  props: {},
  created() {
    this.bug();
    //刷新用户
    this.$api
      .getAPI("mutual/attribute/0?appid=202108&type_id=4001", {
        openid: this.$api.getUserInfo().openid,
        //openid: '8afac2ed6026a8ae01604d88a3f06b14'
      })
      .then((res) => {
        this.$api.getUserInfo_updata(this.$api.getUserInfo().openid);
        //this.$api.getUserInfo_updata("8afac2ed6026a8ae01604d88a3f06b14");
      });
    //this.$api.getUserInfo_updata(this.$api.getUserInfo().);

    //this.bug1();
    //this.bug_main();
    //this.bug2();

    // var storage = window.localStorage;
    // const sUserAgent = window.navigator.userAgent.toLowerCase();
    // const bIsDtDreamApp = sUserAgent.indexOf("dtdreamweb") > -1; // 浙里办APP
    // const bIsAlipayMini =
    // 	sUserAgent.indexOf("miniprogram") > -1 &&
    // 	sUserAgent.indexOf("alipay") > -1;
    // if (bIsDtDreamApp) {
    // 	//浙里办
    // 	storage.setItem("hj", bIsDtDreamApp);
    // 	this.watchApp();
    // } else if (bIsAlipayMini) {
    // 	//支付宝
    // 	storage.setItem("hj2", bIsAlipayMini);
    // 	this.watchApply();
    // }
    // let ticket = this.getQueryVariable("ticket");
    // console.log("ticket");
    // console.log(ticket);
    // console.log("ticket-end");
    // storage.setItem("ticket", ticket);
    // this.ticket = ticket;
    // //用户注册
    // this.$api.getAPI("zlb/login/?appid=202108&type_id=4001", {
    // 	st:ticket
    // }).then(res => {
    // 	// console.log(res);
    // 	const uid = res.data.data.data.userid;
    // 	console.log(uid);
    // 	console.log("add data");
    // 	 let user_model={
    // 	 	openid:uid
    // 	 }
    // 	const rowObj = JSON.stringify(user_model)
    // 	window.sessionStorage.setItem('user_model', rowObj);
    // 	// this.$router.push('/home')
    // })
    // const that = this
    // that.loadPageData()
  },
  mounted() {
    // window.localStorage.setItem('openid', 999999)
  },
  activated() {},
  methods: {
    call() {
      ZWJSBridge.onReady(() => {
        console.log("onReady");
        ZWJSBridge.phoneCall({
          corpId: "0576-88012365",
        })
          .then((res) => {
            console.log(res);
          })
          .catch((err) => {
            console.log(err);
          });
      }).catch(() => {
        console.log("onReadyErr");
      });
    },
    // watchApp() {
    // 	var that = this;
    // 	window.addEventListener(
    // 		"pageshow",
    // 		function(event) {
    // 			if (
    // 				event.persisted ||
    // 				(window.performance && window.performance.navigation.type == 2)
    // 			) {
    // 				setTimeout(() => {
    // 					ZWJSBridge.onReady(() => {
    // 						ZWJSBridge.close();
    // 					});
    // 				}, 10);
    // 			}
    // 			that.isLoad();
    // 		},
    // 		false
    // 	);
    // },
    // watchApply() {
    // 	var that = this;
    // 	window.addEventListener(
    // 		"pageshow",
    // 		function(event) {
    // 			if (
    // 				event.persisted ||
    // 				(window.performance &&
    // 					(window.performance.navigation.type == 1 ||
    // 						window.performance.navigation.type == 0))
    // 			) {
    // 				that.isLoad();
    // 			} else if (
    // 				event.persisted ||
    // 				(window.performance && window.performance.navigation.type == 2)
    // 			) {
    // 				my.navigateBack();
    // 			} else {
    // 				my.navigateBack(); //支付宝小程序的api，需在index.html引入，通过此api直接跳回浙里办小程序页面
    // 			}
    // 		},
    // 		false
    // 	);
    // },
    // isLoad() {
    // 	if (!this.getQueryVariable("ticket")) {
    // 		const sUserAgent = window.navigator.userAgent.toLowerCase();
    // 		const bIsDtDreamApp = sUserAgent.indexOf("dtdreamweb") > -1; // 浙里办APP
    // 		const bIsAlipayMini =
    // 			sUserAgent.indexOf("miniprogram") > -1 &&
    // 			sUserAgent.indexOf("alipay") > -1;
    // 		if (bIsAlipayMini) {
    // 			window.location.href =
    // 				"https://puser.zjzwfw.gov.cn/sso/alipay.do?action=ssoLogin&servicecode=yjz";
    // 		} else {
    // 			window.location.href =
    // 				"https://puser.zjzwfw.gov.cn/sso/mobile.do?action=oauth&scope=1&servicecode=yjz";
    // 		}
    // 	}
    // },
    // //获取url参数
    // getQueryVariable(variable) {
    // 	var query = window.location.search.substring(1);
    // 	console.log("query");
    // 	console.log(query);
    // 	var vars = query.split("&");
    // 	for (var i = 0; i < vars.length; i++) {
    // 		var pair = vars[i].split("=");
    // 		if (pair[0] == variable) {
    // 			return pair[1];
    // 		}
    // 		console.log("pair open");
    // 		console.log(pair);
    // 		console.log("pair end");
    // 	}
    // 	return false;
    // },
    // //埋点
    // getdian() {
    // 	(function(w, d, s, q, i) {
    // 		w[q] = w[q] || [];
    // 		var f = d.getElementsByTagName(s)[0],
    // 			j = d.createElement(s);
    // 		j.async = true;
    // 		j.id = "beacon-aplus";
    // 		j.src = "https://d.alicdn.com/alilog/mlog/aplus.js?id=202951085";
    // 		f.parentNode.insertBefore(j, f);
    // 	})(window, document, "script", "aplus_queue");

    // 	aplus_queue.push({
    // 		action: "aplus.setMetaInfo",
    // 		arguments: ["aplus-waiting", "MAN"],
    // 	});
    // 	aplus_queue.push({
    // 		action: "aplus.setMetaInfo",
    // 		arguments: ["aplus-rhost-v", "alog.zjzwfw.gov.cn"],
    // 	});

    // 	aplus_queue.push({
    // 		action: "aplus.setMetaInfo",
    // 		arguments: ["aplus-rhost-g", "alog.zjzwfw.gov.cn"],
    // 	});

    // 	// 这个会落到app_key字段上
    // 	aplus_queue.push({
    // 		action: "aplus.setMetaInfo",
    // 		arguments: ["appId", "60506758"],
    // 	});
    // 	//应用开发管理平台miniAppId
    // 	aplus_queue.push({
    // 		action: "aplus.sendPV",
    // 		arguments: [{
    // 				is_auto: false,
    // 			},
    // 			{
    // 				miniAppId: "2001836404",
    // 			},
    // 		],
    // 	});
    // 	//应用开发管理平台name
    // 	aplus_queue.push({
    // 		action: "aplus.sendPV",
    // 		arguments: ["miniAppName", "义家助"],
    // 	});
    // 	//  此时被block住的⽇志会携带上⽤户信息逐条发出
    // 	aplus_queue.push({
    // 		action: "aplus.setMetaInfo",
    // 		arguments: ["_hold", "BLOCK"],
    // 	});
    // 	//经度
    // 	aplus_queue.push({
    // 		action: "aplus.sendPV",
    // 		arguments: ["long", `${this.jwd.longitude}`],
    // 	});
    // 	//纬度
    // 	aplus_queue.push({
    // 		action: "aplus.sendPV",
    // 		arguments: ["lati", `${this.jwd.latitude}`],
    // 	});

    // 	//用户类型
    // 	aplus_queue.push({
    // 		action: "aplus.sendPV",
    // 		arguments: ["usertype", `${this.usertype}`],
    // 	});

    // 	// 设置⽤户昵称
    // 	aplus_queue.push({
    // 		action: "aplus.setMetaInfo",
    // 		arguments: ["_user_nick", `${this.user.username}`],
    // 	});
    // 	// 设置⽤户ID
    // 	aplus_queue.push({
    // 		action: "aplus.setMetaInfo",
    // 		arguments: ["_user_id", `${this.user.userid}`],
    // 	});
    // 	//  如采集⽤户信息是异步⾏为，需要先设置完⽤户信息后再执⾏这个START埋点

    // 	//如采集⽤户信息是异步⾏为，需要先设置完⽤户信息后再执⾏这个START埋点
    // 	// 此时被block住的⽇志会携带上⽤户信息逐条发出
    // 	aplus_queue.push({
    // 		action: "aplus.setMetaInfo",
    // 		arguments: ["_hold", "START"],
    // 	});
    // },
    // // 浙里办api获取判断
    // getzlb() {
    // 	ZWJSBridge.onReady(() => {
    // 		//获取用户类型
    // 		ZWJSBridge.getUserType()
    // 			.then((result) => {
    // 				console.log("result1");
    // 				console.log(result);
    // 				console.log("result1-end");
    // 				this.usertype = result.userType;
    // 			})
    // 			.catch((error) => {
    // 				console.log(error);
    // 			});
    // 		//获取经纬度
    // 		ZWJSBridge.getLocation().then((result) => {
    // 			console.log("result2");
    // 			console.log(result);
    // 			console.log("result2-end");
    // 			var jwd = result;
    // 			this.jwd = jwd;
    // 			var storage = window.localStorage;
    // 			storage.setItem("city", jwd.city);
    // 			storage.setItem("lat", jwd.latitude);
    // 			storage.setItem("lon", jwd.longitude);
    // 			console.log(storage.getItem("lat"));
    // 		});
    // 	});
    // },
    // //获取用户信息
    // getuser() {
    // 	var ticket = this.ticket;
    // 	console.log("ticket");
    // 	console.log(ticket);
    // 	mgop({
    // 		api: "mgop.yidian.zycx.http", // 必须
    // 		data: {
    // 			st: ticket,
    // 		},
    // 		type: "POST",
    // 		appKey: "wrqys0ot+2001836404+rorzyk", // 必须
    // 		onSuccess: (data) => {
    // 			console.log("data", data.data.data);
    // 			var user = data.data.data;
    // 			var storage = window.localStorage;
    // 			storage.setItem("id", data.data.id);
    // 			console.log(storage.getItem("id"));
    // 			this.user = user;
    // 			this.getzlb();
    // 			this.getlist();
    // 			console.log("user2");
    // 			console.log(user);
    // 			console.log("user2-end");
    // 		},
    // 		onFail: (err) => {
    // 			console.log(err, "err");
    // 		},
    // 	});
    // },

    loadPageData: function () {},
    bug_main() {
      this.list4 = [];
      this.$api
        .getAPI(
          "mutual/attribute/?appid=202108&type_id=4001&state=1&recommend=4",
          {}
        )
        .then((res) => {
          this.list4 = res.data.data.data[0].models;
        });
    },
    bug() {
      this.$api
        .getAPI("data/page/1", {
          appid: 202108,
          type_id: 1001,
        })
        .then((res) => {
          console.log(res);
          this.list = res.data.data.models.detailedjson;
          // console.log(this.list);
          this.bug1();
        });
    },
    bug1() {
      this.$api
        .getAPI("data/page/2", {
          appid: 202108,
          type_id: 1001,
        })
        .then((res) => {
          // console.log(123);
          // console.log(res.data.data);
          // console.log(res.data.data.models.detailedjson[0]);
          //for (let i = 0; i < res.data.data.models.detailedjson.length - 2; i++) {
          this.buttonList = res.data.data.models.detailedjson;
          this.bug2();
          // console.log(this.buttonList);
          //}
          // this.buttonList1 = []
          // for (let i = 4; i < res.data.data.models.detailedjson.length; i++) {
          // 	this.buttonList1.push(res.data.data.models.detailedjson[i])
          // 	// console.log(this.buttonList);
          // }

          // console.log(this.buttonList);

          // setTimeout(() => {

          //   console.log(123);
          // }, 3000);
        });
    },
    bug2() {
      this.$api
        .getAPI("data/page/6", {
          appid: 202108,
          type_id: 1001,
        })
        .then((res) => {
          //console.log(res);
          //console.log(res)
          this.bug2_data = res.data.data.models.detailedjson;
          //console.log(this.bug2_data);
          //console.log("console.log(this.bug2_data);");
          this.bug_main();
        });
    },
    route(index) {
      this.$router.push(this.buttonList[index].value_a);
    },
    route1: function () {
      this.$router.push(this.bug2_data[0].value_a);
    },
    route2: function () {
      this.$router.push(this.bug2_data[1].value_a);
    },
  },
};
</script>
<style>
/* Make the image fully responsive */
.btn-primary {
  color: #fff;
  background-color: #01b2c2;
  border-color: #01b2c2;
}

.imgss {
  text-align: center;
  width: 100%;
  height: 70px;
  font-size: 16px;
  line-height: 35px;
  border: 1px solid #c0c0c0;
}

.label_50 {
  border-radius: 50px/50px;
}

.page-header {
  margin: 25px 0 0px;
}

.h5_t_5 {
  margin-top: 15px;
}

.b_t_5 {
  padding-top: 6px;
}

.border_ {
  background: #002752;
}

.carousel-inner {
  border-bottom: 1px solid #000;
}

.carousel-indicators {
  bottom: -28px !important;
}

.carousel-indicators li {
  background-color: #000000;
}

.carousel-item-img {
  border-top-left-radius: 0.8em;
  border-top-right-radius: 0.8em;
  background-color: transparent;
  box-shadow: 0px 0px 8px 3px #fff;
}

.border {
  display: inline-block;
  width: 70px;
  height: 70px;
  margin: 6px;
}

.jumbotron {
  padding: 1rem 1rem;
  margin-bottom: 1rem;
}

.jumbotron_aa {
  width: 100%;
  height: 84px;
  padding: 10px 20px !important;
  /* background-image: url("../../assets/bj2.jpg") !important; */
  background-size: 100% 100%;
  background-position: center center;
  color: #fff;
  /* background: #01b2c2; */
  /* background-image: url("../../assets/bj2.jpg");
  background-size: 100% 100%;
  background-position: center center; */
}

.jumbotron_bb {
  width: 100%;
  height: 84px;
  padding: 10px 20px !important;
  /* background-image: url("../../assets/bj1.jpg") !important; */
  background-size: 100% 100%;
  background-position: center center;
  color: #fff;
  /* background: #3480fa; */
}

.jumbotron_c {
  background: #f3f4f8;
}

.carousel-indicators li {
  width: 6px;
  height: 6px;
  background-color: #00cdc6;
}

.carousel-indicators .active {
  background-color: #00a4b7;
  width: 30px;
  height: 7px;
}

.label-primary {
  color: #3480fa;
  background-color: #ffd986;
}

.label-primary-j {
  color: #fff;
  background-color: #00a4b7;
  border-radius: 15px 0px 0px 0px;
}

.label-primary-j1 {
  color: #fff;
  background-color: #00a4b7;
  border-radius: 15px 0px 0px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/home_index.vue